export const ADD_AUTO_RESPONSE    = 'ADD_AUTO_RESPONSE';
export const REMOVE_AUTO_RESPONSE = 'REMOVE_AUTO_RESPONSE';
export const SET_AUTO_RESPONSES   = 'SET_AUTO_RESPONSES';
export const UPDATE_AUTO_RESPONSE = 'UPDATE_AUTO_RESPONSE';
export const SELECT_AUTO_RESPONSE = 'SELECT_AUTO_RESPONSE';
